module.exports = __webpack_public_path__ + "img/plus.5d91bcc5.svg";